import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2 className ='text-danger'>Your Page is Not Founded</h2>
        </div>
    );
};

export default NotFound;